<br />
<div fxLayout="row wrap" fxFlex="100%;" class="plant-layout">
  <div fxLayout="row wrap" fxFlex="100%;" fxLayout.xs="column wrap">
    <div fxLayout="column wrap" fxFlex="70%;" style="margin-right: 10px">
      <div class="plant-status-key-wrapper">
        <app-plant-status></app-plant-status>
      </div>
    </div>
    <div fxLayout="column wrap" fxFlex="28%;">
      <div class="solar-expansion-wrapper">
        <app-performance-characteristic></app-performance-characteristic>
      </div>
    </div>
  </div>
  <div fxLayout="row wrap" fxFlex="100%;" fxLayout.xs="column wrap">
    <div
      fxLayout="column"
      fxFlex="50%;"
      fxFlex.sm="100%"
      fxLayout.sm="column"
      style="margin-right: 10px"
    >
      <div class="solar-expansion-wrapper">
        <app-power-irradiance
          [resizeSubscription]="resizeSubject"
        ></app-power-irradiance>
      </div>
    </div>
    <div fxLayout="column" fxFlex="48%;" fxFlex.sm="100%" fxLayout.sm="column">
      <div class="solar-expansion-wrapper">
        <app-solar-yield [resizeSubscription]="resizeSubject"></app-solar-yield>
      </div>
    </div>
  </div>
  <div fxLayout="row wrap" fxFlex="98%;" fxLayout.xs="column wrap">
    <div class="solar-expansion-wrapper energy-container">
      <app-solar-energy></app-solar-energy>
    </div>
  </div>
</div>
